import { useTranslation } from 'react-i18next';

import styles from './OfferingPriceTooltipLabel.module.scss';

export const OfferingPriceTooltipLabel = ({
  minPrice,
  maxPrice,
}: {
  minPrice: string;
  maxPrice: string;
}) => {
  const { t } = useTranslation('screener');
  const formattedMinPrice = parseFloat(minPrice).toFixed(2);
  const formattedMaxPrice = parseFloat(maxPrice).toFixed(2);
  return (
    <div className={styles.root}>
      <div className={styles.flexColumnWrapper}>
        <div data-testid="offering-price-minimum">
          {t('screener:screenerEvents.minimum')}
        </div>
        <div data-testid="offering-price-minimum-value">
          {formattedMinPrice}
        </div>
      </div>
      <div className={styles.verticalLineDivider} />
      <div className={styles.flexColumnWrapper}>
        <div data-testid="offering-price-maximum">
          {t('screener:screenerEvents.maximum')}
        </div>
        <div data-testid="offering-price-maximum-value">
          {formattedMaxPrice}
        </div>
      </div>
    </div>
  );
};
